import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';

@Entity()
export class AGArbeit extends AdornisEntity {
  static override _class = 'AGArbeit';

  static override resolveID(entity: AGArbeit): string {
    entity._id ??= A.getGloballyUniqueID();
    return entity._id;
  }

  @Field(() => ID, { default: v => v ?? A.getGloballyUniqueID() }) _id!: string;

  @Field(() => Date)
  beginBeschaftigungMeldung: Maybe<Date>;

  @validate(({ value, key, target }) => {
    if (!value || !target.beginBeschaftigungMeldung) return;
    if (value <= target.beginBeschaftigungMeldung)
      throw new ValidationError('Ende der Beschäftigung muss nach Beginn liegen.', { key, target });
  })
  @Field(() => Date)
  endeBeschaftigungMeldung: Maybe<Date>;

  @Field(() => Boolean, { default: v => v ?? false })
  monatlichesArbeitsentgeltGroesserAls520Euro: Maybe<boolean>;

  @Field(() => Int)
  tatsachlicheArbeitstageInDiesemZeitraum: Maybe<number>;

  @Field(() => String)
  arbeitgeberMitAdresse: Maybe<string>;
}
